import { StringObject } from '@/context/types'

export const STATUS: StringObject = {
  NEW: 'New',
  PENDING_ESTIMATE: 'Pending Estimate',
  ESTIMATE_COMPLETE: 'Estimate Complete',

  FOR_OWNER_APPROVAL: 'For Owner Approval',
  PENDING_APPROVAL: 'Pending Approval',

  UPCOMING_VISIT: 'Upcoming Visit',
  IN_PROGRESS: 'In Progress',
  COMPLETE: 'Complete',
  COMPLETE_BILLED: 'Complete (Billed)',
  COMPLETE_NOT_BILLED: 'Complete (Not Billed)',
  DEFERRED: 'On Hold',
  CANCELLED: 'Cancelled',
}

export const WORK_ORDER_STATUS: StringObject = {
  [STATUS.NEW]: STATUS.PENDING_ESTIMATE,
  [STATUS.PENDING_ESTIMATE]: STATUS.PENDING_ESTIMATE,
  [STATUS.ESTIMATE_COMPLETE]: STATUS.PENDING_ESTIMATE,
  [STATUS.FOR_OWNER_APPROVAL]: STATUS.FOR_OWNER_APPROVAL,
  [STATUS.PENDING_APPROVAL]: STATUS.FOR_OWNER_APPROVAL,
  [STATUS.IN_PROGRESS]: STATUS.UPCOMING_VISIT,
  [STATUS.UPCOMING_VISIT]: STATUS.UPCOMING_VISIT,
  [STATUS.COMPLETE]: STATUS.COMPLETE,
  [STATUS.COMPLETE_BILLED]: STATUS.COMPLETE_BILLED,
  [STATUS.COMPLETE_NOT_BILLED]: STATUS.COMPLETE_NOT_BILLED,
  [STATUS.DEFERRED]: STATUS.DEFERRED,
  [STATUS.CANCELLED]: STATUS.CANCELLED,
}

export const WORK_ORDER_STATUS_STYLE: StringObject = {
  'Pending Estimate': 'pmui-info-no-action-status',
  'Get New Estimate': 'pmui-info-no-action-status',
  'Upcoming Visit': 'pmui-info-no-action-status',
  'For Owner Approval': 'pmui-info-needs-action-status',
  Complete: 'pmui-done-status',
  'Complete (Billed)': 'pmui-done-status',
  'Complete (Not Billed)': 'pmui-done-status',
  'On Hold': 'pmui-no-action-status',
  Cancelled: 'pmui-no-action-status',
}

export const WORK_ORDER_PRIORITY_STYLE: StringObject = {
  Common: 'work-order-priority-common',
  Habitability: 'work-order-priority-habitability',
  Emergency: 'work-order-priority-emergency',
}

export const CAROUSEL_TYPES: StringObject = {
  WORK_ORDERS: 'pmui_carousel_work_orders',
  PROPERTIES: 'pmui_carousel_properties',
}

export const WORK_ORDER_STATUS_TABS: StringObject = {
  [STATUS.PENDING_ESTIMATE]: 'PENDING_ESTIMATE',
  [STATUS.FOR_OWNER_APPROVAL]: 'FOR_OWNER_APPROVAL',
  [STATUS.UPCOMING_VISIT]: 'UPCOMING_VISIT',
  Closed: 'CLOSED',
  [STATUS.DEFERRED]: 'ON_HOLD',
}

export const PROPERTY_STATUS: StringObject = {
  ACTIVE: 'ACTIVE',
  LEASED: 'LEASED',
  NEW: 'NEW',
  TERMINATED: 'TERMINATED',
}

export const PROPERTY_STAGES: StringObject = {
  IN_SALES: 'In Sales',
  IN_LEASING: 'In Leasing',
  IN_RELEASING: 'In Releasing',
}

export const LISTING_STATUS: StringObject = {
  COMING_SOON: 'COMING_SOON',
  ACTIVE: 'ACTIVE',
}

export const ACTIVE_LISTING_STATUS: string[] = [
  LISTING_STATUS.ACTIVE,
  LISTING_STATUS.COMING_SOON,
]

export const OCCUPANCY: StringObject = {
  VACANT: 'Vacant',
  RENTER_OCCUPIED: 'Occupied',
  ONERENT_RENTER_OCCUPIED: 'Onerent Renter Occupied',
  OWNER_OCCUPIED: 'Owner Occupied',
}

export const OCCUPANCY_KEYS: StringObject = {
  VACANT: 'VACANT',
  OWNER_OCCUPIED: 'OWNER_OCCUPIED',
  RENTER_OCCUPIED: 'RENTER_OCCUPIED',
  ONERENT_RENTER_OCCUPIED: 'ONERENT_RENTER_OCCUPIED',
}

export const CARD_SELECT_TYPE: StringObject = {
  CATEGORY: 'category-card',
  WORK_ORDER: 'work-order-card',
  PROPERTY: 'property-card',
}

export default {
  STATUS,
  WORK_ORDER_STATUS_STYLE,
  WORK_ORDER_PRIORITY_STYLE,
  WORK_ORDER_STATUS,
  CAROUSEL_TYPES,
  CARD_SELECT_TYPE,
}
